import { z } from "zod";

import request from "../base-request";

export const GroupSchema = z.object({
	id: z.string(),
	name: z.string(),
	company: z
		.object({
			_id: z.string(),
			name: z.string(),
		})
		.optional(),
});

export type Group = z.infer<typeof GroupSchema>;

export interface IGroupData {
	groups: Group[];
	errors: string[];
	warnings: string[];
}

export const getGroups = async () => {
	try {
		const [groupData] = await request<IGroupData>(`/api/v1.0/groups`);

		return groupData;
	} catch (e) {
		throw new Error(e);
	}
};
